import React from "react";
import { ExternalLink, Globe, ShoppingBag, Sparkles } from "lucide-react";
import { useI18n } from "../i18n";
import { Section, SectionHeading } from "./Section";
import { OFFICIAL_LINKS } from "../config/site";

export default function OfficialLinks() {
  const { d } = useI18n();
  const links = [
    { key: "website", href: OFFICIAL_LINKS.website, label: d.ui.officialWebsite, desc: d.officialSection.websiteDesc, Icon: Globe },
    { key: "store", href: OFFICIAL_LINKS.store, label: d.ui.officialStore, desc: d.officialSection.storeDesc, Icon: ShoppingBag },
    { key: "onthejlo", href: OFFICIAL_LINKS.onthejlo, label: d.ui.onTheJlo, desc: d.officialSection.onthejloDesc, Icon: Sparkles },
  ];

  return (
    <Section testid="official-links">
      <SectionHeading heading={d.officialSection.heading} subtitle={d.officialSection.subtitle} align="center" />
      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {links.map(({ key, href, label, desc, Icon }) => (
          <a
            key={key}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`official-link-${key}`}
            aria-label={`${label} ${d.ui.opensNewTab}`}
            className="focus-gold group relative rounded-2xl border border-jlo-gold/25 bg-jlo-bg2 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-jlo-gold/70"
          >
            <div className="flex items-center justify-between">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-jlo-gold/30 text-jlo-gold">
                <Icon className="h-6 w-6" aria-hidden="true" />
              </span>
              <ExternalLink className="h-5 w-5 text-jlo-gray group-hover:text-jlo-gold transition-colors" aria-hidden="true" />
            </div>
            <h3 className="mt-5 font-display text-xl font-semibold text-jlo-warm group-hover:text-jlo-gold transition-colors">{label}</h3>
            <p className="mt-2 text-sm text-jlo-warm/70 leading-relaxed">{desc}</p>
          </a>
        ))}
      </div>
      <p className="mt-8 text-center text-xs text-jlo-gray">{d.officialSection.note}</p>
    </Section>
  );
}
